import THREE from "./Three";
import animations from "../components/Animations";

export function loadingManager() {
  const manager = new THREE.LoadingManager();
  const loader = document.getElementById("loader");
  const progressContainer = document.getElementById("progress");
  const coordinates = document.getElementById("coordinates");
  const webcamActivate = document.getElementById("webcam-activate");

  let loadingCompleted = false;

  const timeline = triggerProgressLoading(coordinates);

  timeline.play();

  manager.onLoad = () => {
    loadingCompleted = true;
    timeline.pause();

    const startFinalAnimation = () => {
      animations
        .timeline({})
        .to(coordinates, {
          duration: 0.6,
          scrambleText: {
            text: "48.8566° N, 2.3522° E",
            chars: "0123456789",
          },
        })
        .to(webcamActivate, {
          delay: 0.5,
          duration: 0.6,
          opacity: 1,
        })
        .then(() => {
          window.scrollTo(0, 0);
          transition(progressContainer, loader);
        });
    };

    if (loadingCompleted) {
      startFinalAnimation();
    } else {
      timeline.eventCallback("onComplete", startFinalAnimation);
    }
  };

  return manager;
}

function triggerProgressLoading(coordinates) {
  const timeline = animations
    .timeline({
      defaults: {
        repeat: -1,
        yoyo: true,
        repeatRefresh: true,
      },
    })
    .to(coordinates, {
      delay: 0.6,
      duration: 0.6,
      scrambleText: {
        text: "68.5862° N, 2.3258° E",
        chars: "0123456789",
      },
    })
    .to(coordinates, {
      delay: 0.6,
      duration: 0.6,
      scrambleText: {
        text: "84.2566° N, 3.3252° E",
        chars: "0123456789",
      },
    })
    .to(coordinates, {
      delay: 0.6,
      duration: 0.6,
      scrambleText: {
        text: "46.8652° N, 2.2536° E",
        chars: "0123456789",
      },
    })
    .to(coordinates, {
      delay: 0.6,
      duration: 0.6,
      scrambleText: {
        text: "28.6253° N, 5.2352° E",
        chars: "0123456789",
      },
    })
    .to(coordinates, {
      delay: 0.6,
      duration: 0.6,
      scrambleText: {
        text: "52.3258° N, 6.6822° E",
        chars: "0123456789",
      },
    });

  return timeline;
}

const transition = (container, loader) => {
  animations.to(container, {
    delay: 1.5,
    autoAlpha: 0,
    duration: 1.5,
    onComplete: () => {
      container.classList.remove("active");
      loader.classList.add("remove");
    },
  });
};
